export default "__VITE_ASSET__CIbv$sLH__"